
import { defineComponent } from 'vue'
import AzuriomInstaller from './views/AzuriomInstaller.vue'

export default defineComponent({
  name: 'App',
  components: {
    AzuriomInstaller,
  },
})
